import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=8389f2ec&scoped=true"
import script from "./SEO.vue?vue&type=script&lang=js"
export * from "./SEO.vue?vue&type=script&lang=js"
import style0 from "./SEO.vue?vue&type=style&index=0&id=8389f2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8389f2ec",
  null
  
)

export default component.exports